import React from "react";
import "../assets/Menu.css";


const Menu = ({
  isDeviceOn
}) => {

  
    return (
      <div className="header neuButtonS">
        <div className="logoCluster">
          <img className="logo" src="logoOrange.svg" alt="logo"/>
          <div className="logoClusterLower">
            {isDeviceOn ? <div className="statusIconG"></div> : <div className="statusIcon"></div> }
            <p>v1.0.0 Released Jan 2025</p>
          </div>
        </div>
        <div className="menuLinks">
          <a href="https://shop.minimaldesksetups.com/pages/flowtimer">Project</a>
          <a href="https://shop.minimaldesksetups.com/pages/flow-timer-features-specifications">Features</a>
          <a href="https://www.minimaldesksetups.com/flow-timer-by-mds/">Progress</a>
        </div>
        <a href="https://www.surveymonkey.com/r/X8XLDMM" className="feedbackButton">Leave Feedback</a> 
      </div>
    );

};
  
  export default Menu;